import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Box, Typography } from '@mui/material';

import SimpleVoucherForm from '~/components/Vouchers/SimpleVoucherForm';

/** Bookmarkable full-page entry for the quick voucher form (same behaviour as the Marketing tab). */
export default function QuickCreateVoucherPage() {
  return (
    <Box sx={{ px: { xs: 1, sm: 2 }, pt: 2, pb: 4 }}>
      <Typography variant="body2" sx={{ mb: 2 }}>
        <Link to="/marketing/vouchers-simple-create">Open inside Marketing (tabs)</Link>
      </Typography>
      <SimpleVoucherForm mode="page" />
    </Box>
  );
}
